angular
  .module('ordersRates')
  .component('ordersRates', {
    template: require('./orders-rates.template.html'),
    controller: ['$rootScope', '$scope', '$resource', '$route', '$location', '$window', '$translate', 'AuthService', 'envService',
      function OrdersRatesController($rootScope, $scope, $resource, $route, $location, $window, $translate, AuthService, envService) {
        $scope.showEmployeeView = $rootScope.gShowEmployeeView;
        $scope.showUserView = $rootScope.gShowUserView;
        $scope.gShowOrderView = $rootScope.gShowOrderView;
        $scope.orderFunc = $rootScope.orderFunc;
        $rootScope.mainmenu = 'orders';
        $rootScope.menu = 'rates';
        this.show_3_or_lower = true;
        this.show_recent = true;
        const APIURL = envService.read('apiUrl');
        if (!AuthService.isAuthenticated()) {
          $location.path('/login');
          return;
        }
        $scope.paging = (page) => {
          $resource(`${APIURL}/admin/rates`).get({ page: page - 1, include_4_5: this.show_3_or_lower ? 'false' : 'true', recent: this.show_recent ? 'true' : 'false', tb_user_id_employee: $scope.targetEmployeeId }, (data) => {
            this.rates = data.rates;
            this.total_count = data.total_count;
          }, (err) => {
            console.error(err);
            if (err.data && err.data.msg) {
              alert(err.data.msg);
            } else {
              alert($translate.instant('알수 없는 에러 입니다.'));
            }
          });
        };
        $scope.rateEdit = { rate: null, next: null, saving: false, error: '' };
        $scope.showRateInput = (rate) => {
          $scope.rateEdit.rate = rate;
          $scope.rateEdit.next = Number(rate.RATE);
          $scope.rateEdit.saving = false;
          $scope.rateEdit.error = '';
          jQuery('#modal-rate-edit').modal('show');
        };
        $scope.saveRate = () => {
          const next = Number($scope.rateEdit.next);
          const rate = $scope.rateEdit.rate;
          if (!rate || !Number.isInteger(next) || next < 1 || next > 5) {
            $scope.rateEdit.error = $translate.instant('별점을 선택해주세요');
            return;
          }
          if (next === Number(rate.RATE)) {
            jQuery('#modal-rate-edit').modal('hide');
            return;
          }
          $scope.rateEdit.saving = true;
          $scope.rateEdit.error = '';
          $resource(`${APIURL}/admin/orders/${rate.ORDER_NO}/rate`).save({ RATE: next }, () => {
            rate.RATE = next;
            rate.RERATE = 'Y';
            $scope.rateEdit.saving = false;
            jQuery('#modal-rate-edit').modal('hide');
          }, (err) => {
            console.error(err);
            $scope.rateEdit.saving = false;
            if (err.data && err.data.msg) {
              $scope.rateEdit.error = err.data.msg;
            } else {
              $scope.rateEdit.error = $translate.instant('알수 없는 에러 입니다.');
            }
          });
        };
        $scope.showCommentAdminInput = (rate) => {
          const comment = $window.prompt($translate.instant('노트를 입력해주세요'));
          if (comment === null) { // cancel
            return;
          }
          $resource(`${APIURL}/admin/orders/${rate.ORDER_NO}/adminComment`).save({ COMMENT: comment }, () => {
            rate.COMMENT_ADMIN = comment;
          }, (err) => {
            console.error(err);
            if (err.data && err.data.msg) {
              alert(err.data.msg);
            } else {
              alert($translate.instant('알수 없는 에러 입니다.'));
            }
          });
        };

        $scope.employeeChanged = () => {
          this.total_count = 0;
          $scope.paging(1);
        };

        $resource(`${APIURL}/admin/employees?count=10000&include_unregister=false`).get((data) => {
          $scope.employees = data.users;
          $scope.targetEmployeeId = '-1';
          $scope.employeeChanged();
        }, (err) => {
          console.error(err);
          if (err.data && err.data.msg) {
            alert(err.data.msg);
          } else {
            alert($translate.instant('알수 없는 에러 입니다.'));
          }
        });
      },
    ],
  });



// WEBPACK FOOTER //
// ./src/app/orders-rates/orders-rates.component.js